import React, { ReactElement, useEffect, useState } from 'react';

import Modal from 'components/Modal';
import Text from 'components/Text';
import { useWizard } from 'contexts/WizardProvider';
import { useHotjarDisable } from 'hooks/useHotjarDisable';
import { useNavigation } from 'hooks/useNavigation';
import { beautifyPrice } from 'utils/getFormattedPrice';
import { classNames } from 'utils/css';
import route from 'constants/route';
import { LandingModalBase } from 'components/LandingModalBase';

import { useUserFlag } from 'contexts/UserFlagProvider';
import getRaffleLandingModalConfig from './RaffleLandingModal.config';
import styles from './RaffleLandingModal.module.scss';
import getRaffleConfigs from '../../../../Raffle.config';

function RaffleLandingModal(): ReactElement {
  useHotjarDisable();
  const { navigate } = useNavigation();
  const wizard = useWizard();
  const { landingModal } = getRaffleLandingModalConfig();
  const { userFlags, saveUserFlag, mobileFlagHandlerAvailable } = useUserFlag();
  const { landingModalShowingCount } = getRaffleConfigs();

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const show =
      !wizard.raffleLandingModalViewsIncreased &&
      (userFlags.raffleLandingModalNumberOfViews as number) %
        landingModalShowingCount ===
        0;

    !showModal && setShowModal(show);

    userFlags.raffleLandingModalNumberOfViews !== undefined &&
      !wizard.raffleLandingModalViewsIncreased &&
      saveRaffleLandingModalSeen();
  }, [userFlags.raffleLandingModalNumberOfViews]);

  function handleOnClose() {
    const element = document.getElementById('_hj_feedback_container');
    if (element) {
      element.style.display = 'inherit';
    }
    setShowModal(false);
  }

  function saveRaffleLandingModalSeen() {
    wizard.setRaffleLandingModalViewsIncreased();
    if (mobileFlagHandlerAvailable) {
      increaseModalSeenCount();
    }
  }

  function handlePrimaryButtonClick() {
    increaseModalSeenCount();
    navigate(route.raffles);
  }

  function increaseModalSeenCount() {
    mobileFlagHandlerAvailable &&
      saveUserFlag(
        'raffleLandingModalNumberOfViews',
        (userFlags.raffleLandingModalNumberOfViews || 0) + 1
      );
  }

  return (
    <Modal
      base={LandingModalBase}
      onClose={handleOnClose}
      onPrimaryClick={handlePrimaryButtonClick}
      primaryActionText="Hemen Bilet Al"
      visible={showModal && landingModal.enabled}>
      <div className={styles.imageWrapper}>
        <img
          data-testid="RaffleLandingModalImage"
          src={landingModal.imageUrl}
          alt={landingModal.imageAlt}
        />
      </div>
      <div className={styles.textsWrapper}>
        <Text color="white" className={styles.title} weight="semiBold">
          {landingModal.title}
        </Text>
        <Text color="white" as="div" size="small">
          Toplam Yaklaşık Ürün Değeri
        </Text>
        <Text
          color="white"
          as="div"
          weight="bold"
          size="large"
          data-testid="TotalEstimatedPrize"
          className={styles.totalEstimatedPrize}>
          {beautifyPrice(landingModal.totalEstimatedPrize)}
        </Text>
        <div className={styles.divider} />
        <ul className={styles.prizeList}>
          {landingModal.prizeList.map((prize) => (
            <li key={`prize-${prize.name}`}>
              <Text
                size="large"
                color="white"
                className={classNames(styles.prizeText, styles.animatedText)}
                as="span">{`${prize.quantity} ${prize.name}`}</Text>
            </li>
          ))}
        </ul>
        <Text color="white" as="div" className={styles.moreText}>
          Ve daha fazlası
        </Text>
      </div>
    </Modal>
  );
}

export default RaffleLandingModal;
